import React from "react";
import { TaskListView, DeviceList, TaskDetails } from "../TaskCommonComponents";
import { Reboot } from "./Reboot";
import { PMReports } from "./PMReports";
import { SoftwareDownloadAndUpdate } from "./SoftwareDownloadAndUpdate";
import { BulkConfiguration } from "./BulkConfiguration";
import { RadioNodeReplace } from "./RadioNodeReplace";
import { CellEnableDisable } from "./CellEnableDisable";
import { SNDbBackup } from "./SNDbBackup";
import { SNDbRestore } from "./SNDbRestore";
import { SoftwareUpdate } from "./SoftwareUpdate";
import { RadioNodeOperations } from "./RadioNodeOperations";
import { ExportSnDataModel } from "./ExportSnDataModel";
import { SetDebugLevel } from "./SetDebugLevel/SetDebugLevel";
import { SetLCIPassword } from "./SetLCIPassword";
import { NodePasswordChange } from "./NodePasswordChange";
import { RadioUnitLogBundle } from "./RadioUnitLogBundle";
import { LteRNLocation } from "./LteRNLocation";
import { LTESelfConfiguration } from "./LTESelfConfiguration";
import { NodeFileManagement } from "./FileManagement/NodeFileManagement";
import { TestSnmpTrap } from "./TestSnmpTrap";
import { LTERemStart } from "./LTERemStart";
import AuditReports from "./AuditReport/AuditReports";
import CustomAuditReport from "./AuditReport/CustomAuditReport";


interface Step {
  title?: string;
  component: React.ReactNode; // Use React.ReactNode for components
}

interface Steps {
  [stepName: string]: Step[];
}

export const step1st2nd = [
  //this is comman steps for all task
  {
    title: "Choose the preferred action to be attached to this task:",
    component: <TaskListView />,
  },
  {
    title: "Select the devices that will execute this task",
    component: <DeviceList />,
  },
];

export const lastStep =
  //this is comman last steps for all task
  {
    title: "Task Details",
    component: <TaskDetails />,
  };

//Add new task component below
export const taskListComponent = {
  reboot: [
    {
      title: "Reboot the node or the radio node",
      component: <Reboot />,
    },
  ],
  pmReports: [
    {
      title: "PM Report",
      component: <PMReports />,
    },
  ],
  auditReports: [
    {
      title: "Audit Report",
      component: <AuditReports />,
    },
  ],
  customAuditReport: [
    {
      title: "Custom Audit Report",
      component: <CustomAuditReport />,
    },
  ],
  softwareDownloadUpdate: [
    {
      title: "Software Download And Update parameters",
      component: <SoftwareDownloadAndUpdate taskFor="softwareDownloadUpdate" />,
    },
  ],
  bulkConfiguration: [
    {
      title: "Select Configuration Template",
      component: <BulkConfiguration />,
    },
  ],
  radioNodeReplace: [
    {
      title: "Radio Node Replace",
      component: <RadioNodeReplace />,
    },
  ],
  lteCell: [
    {
      title: "LTE Cell Enable/Disable",
      component: <CellEnableDisable cellType={"LTE"} />,
    },
  ],
  nrCell: [
    {
      title: "NR Cell Enable/Disable",
      component: <CellEnableDisable cellType={"NR"} />,
    },
  ],
  snDbBackup: [
    {
      title: "Node Database Backup",
      component: <SNDbBackup />,
    },
  ],
  snDbRestore: [
    {
      title: "Node Database Restore",
      component: <SNDbRestore />,
    },
  ],
  softwareDownload: [
    {
      title: "File Download parameters",
      component: <SoftwareDownloadAndUpdate taskFor="softwareDownload" />,
    },
  ],
  softwareUpdate: [
    {
      title: "Node Software Update Parameters",
      component: <SoftwareUpdate />,
    },
  ],
  radioNodeOperations: [
    {
      title: "Radio Node LED Operations",
      component: <RadioNodeOperations />,
    },
  ],
  exportSnDataModel: [
    {
      title: "Export Node Data Model",
      component: <ExportSnDataModel />,
    },
  ],
  setDebug: [
    {
      component: <SetDebugLevel />,
    },
  ],
  lciSetPassword: [
    {
      component: <SetLCIPassword />,
    },
  ],
  setPassword: [
    {
      title: "Node Password Change",
      component: <NodePasswordChange />,
    },
  ],
  radiounitTroubleshooting: [
    {
      title: "RU Log Bundle",
      component: <RadioUnitLogBundle />,
    },
  ],
  lteRnLocation: [
    {
      title: "LTE RN Location",
      component: <LteRNLocation />,
    },
  ],
  lteSelfConfig: [
    {
      title: "LTE Self Configuration",
      component: <LTESelfConfiguration />,
    },
  ],
  fileManagementCreate: [
    {
      title: "Node File Management",
      component: <NodeFileManagement />,
    },
  ],
  testSnmpTrap: [
    {
      title: "Test SNMP Trap",
      component: <TestSnmpTrap />,
    },
  ],
  lteRemStart: [
    {
      title: "LTE REM Start",
      component: <LTERemStart />,
    },
  ],
} as Steps;
